var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-c-center noRecord"},[_c('img',{attrs:{"src":require("@/assets/immunity/无数据.png"),"alt":"","srcset":""}}),_c('span',{staticClass:"noRecord_text"},[_vm._v(_vm._s(_vm.text))]),(_vm.isBtn)?_c('van-button',{attrs:{"type":"info","round":""},on:{"click":_vm.goUrl}},[_vm._v(_vm._s(_vm.btnText))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }